module.exports = __webpack_public_path__ + "media/images/icons/icon_caret_down_black-054c0fa39f41cd0b41d5948fde7d3843.svg";